export const runOnBrowser = <T>(fn: () => T, defaultValue: T): T => {
  return typeof window === 'undefined' ? defaultValue : fn()
}
